export const environment = {
  production: false,
  apiUrl: 'https://krhjrnnfx1.execute-api.eu-central-1.amazonaws.com/v1', // Placeholder
};


